import {
  buildCloneSparklineColumns,
  type CloneSparklineColumns,
} from '@/features/shared/components/cloneTable/cloneSparklineColumns';
import type { MetricThresholdGroup, TestListItemDto } from '@flowqa/shared';

type BuildSparklineColumnsArgs = {
  passRateAsSparklineCell: boolean;
  frequencyAsSparklineCell: boolean;
  avgDurationAsSparklineCell: boolean;
  showDeltas: boolean;
  resolvedThresholds: (row: TestListItemDto) => MetricThresholdGroup;
  metricSeriesByTestId?: Map<
    string,
    {
      dates: Date[];
      passRate: number[];
      frequencyPerDay: number[];
      averageDurationMs: number[];
    }
  >;
  columnFlex: {
    passRate: number;
    frequency: number;
    avgDuration: number;
  };
};

type SparklineColumns = CloneSparklineColumns<TestListItemDto>;

const cellClassNames = {
  passRate: 'tests-table-clone-passrate-cell',
  frequency: 'tests-table-clone-frequency-cell',
  avgDuration: 'tests-table-clone-avgduration-cell',
} as const;

export const buildSparklineColumns = ({
  passRateAsSparklineCell,
  frequencyAsSparklineCell,
  avgDurationAsSparklineCell,
  showDeltas,
  resolvedThresholds,
  metricSeriesByTestId,
  columnFlex,
}: BuildSparklineColumnsArgs): SparklineColumns => {
  return buildCloneSparklineColumns<TestListItemDto>({
    passRateAsSparklineCell,
    frequencyAsSparklineCell,
    avgDurationAsSparklineCell,
    showDeltas,
    resolvedThresholds,
    metricSeriesById: metricSeriesByTestId,
    columnFlex,
    cellClassNames,
  });
};
